/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Status_BuildingInputs */

const en_us2_community_status_building = /** @type {(inputs: Community_Status_BuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Being built`)
};

const pt_br2_community_status_building = /** @type {(inputs: Community_Status_BuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em construção`)
};

const es_419_community_status_building = /** @type {(inputs: Community_Status_BuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En construcción`)
};

const pt_pt2_community_status_building = /** @type {(inputs: Community_Status_BuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em construção`)
};

const fr_fr2_community_status_building = /** @type {(inputs: Community_Status_BuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours`)
};

const de_de2_community_status_building = /** @type {(inputs: Community_Status_BuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Arbeit`)
};

const it_it2_community_status_building = /** @type {(inputs: Community_Status_BuildingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In sviluppo`)
};

/**
* | output |
* | --- |
* | "Being built" |
*
* @param {Community_Status_BuildingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_status_building = /** @type {((inputs?: Community_Status_BuildingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Status_BuildingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_status_building(inputs)
	if (locale === "es-419") return es_419_community_status_building(inputs)
	if (locale === "pt-PT") return pt_pt2_community_status_building(inputs)
	if (locale === "fr-FR") return fr_fr2_community_status_building(inputs)
	if (locale === "de-DE") return de_de2_community_status_building(inputs)
	if (locale === "it-IT") return it_it2_community_status_building(inputs)
	return en_us2_community_status_building(inputs)
});
export { community_status_building as "community.status_building" }